<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body{
  margin: 0;
}
:root {
  --theme-color: #E6EDFF; /* 自定义全局主题色 */
  --theme-text-color: rgb(0 81 106);
}
</style>
